import React, { useEffect, useState } from "react";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import {
  GetHostelList,
  HostelBedsList,
  HostelRoomList,
  HostelStudentList,
} from "../../api/HostelService";
import { printElement } from "../master/Print";

export default function StudentsModal({ type }) {
  const [loading, setLoading] = useState(false);
  const [hostels, setHostels] = useState([]);
  const [beds, setBeds] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [students, setStudents] = useState([]);
  const [filters, setFilters] = useState({});

  const getHostelList = async () => {
    setLoading(true);
    try {
      const response = await GetHostelList(`limit=all`);
      if (response.data?.status) {
        setHostels(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getHostelRoomsList = async () => {
    setLoading(true);
    let addUrl = `limit=all`;
    if (filters?.hostel_id) {
      addUrl += `&hostel_id=${filters?.hostel_id}`;
    }
    try {
      const response = await HostelRoomList(addUrl);
      if (response.data?.status) {
        setRooms(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getHostelBedsList = async () => {
    setLoading(true);
    let addUrl = `limit=all`;
    if (filters?.hostel_id) {
      addUrl += `&hostel_id=${filters?.hostel_id}`;
    }
    if (filters?.room_id) {
      addUrl += `&room_id=${filters?.room_id}`;
    }
    try {
      const response = await HostelBedsList(addUrl);
      if (response.data?.status) {
        setBeds(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getHostelStudents = async () => {
    setLoading(true);

    let addUrl = "limit=all";

    // Card se aane wala filter
    if (type === "active") {
      addUrl += "&status=1";
    } else if (type === "inactive") {
      addUrl += "&status=2";
    }

    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });

    try {
      const response = await HostelStudentList(addUrl);

      if (response.data?.status) {
        setStudents(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHostelList();
  }, []);

  useEffect(() => {
    getHostelRoomsList();
  }, [filters?.hostel_id]);

  useEffect(() => {
    getHostelBedsList();
  }, [filters?.hostel_id, filters?.room_id]);

  useEffect(() => {
    getHostelStudents();
  }, [filters, type]);

  return (
    <>
      {loading && <LoadingDiv />}

      <div
        className="modal fade"
        id="StudentData"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header py-3 bg-label-primary">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Hostel Students
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row align-items-center">
                <div className="col-md-2 col-sm-6">
                  <div className="form-floating form-floating-outline">
                    <select
                      name="hostel_id"
                      id="hostel_id"
                      className="form-select"
                      value={filters?.hostel_id}
                      onChange={(e) =>
                        setFilters({ ...filters, hostel_id: e.target.value })
                      }
                    >
                      <option value="">All</option>
                      {hostels?.map((hostel, i) => (
                        <option value={hostel?.id}>{hostel?.name}</option>
                      ))}
                    </select>
                    <label htmlFor=""> Select Hostel </label>
                  </div>
                </div>
                <div className="col-md-2 col-sm-6">
                  <div className="form-floating form-floating-outline">
                    <select
                      name="room_id"
                      id="room_id"
                      className="form-select"
                      value={filters?.room_id}
                      onChange={(e) =>
                        setFilters({ ...filters, room_id: e.target.value })
                      }
                    >
                      <option value="">All</option>
                      {rooms?.map((room, i) => (
                        <option value={room?.id}>{room?.room_no}</option>
                      ))}
                    </select>
                    <label htmlFor=""> Select Room </label>
                  </div>
                </div>
                <div className="col-md-2 col-sm-6">
                  <div className="form-floating form-floating-outline">
                    <select
                      name="bed_id"
                      id="bed_id"
                      className="form-select"
                      value={filters?.bed_id}
                      onChange={(e) =>
                        setFilters({ ...filters, bed_id: e.target.value })
                      }
                    >
                      <option value="">All</option>
                      {beds?.map((bed, i) => (
                        <option value={bed?.id}>{bed?.bed_no}</option>
                      ))}
                    </select>
                    <label htmlFor=""> Select Bed </label>
                  </div>
                </div>
                <div className="col-md-2 col-sm-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="search"
                      placeholder="Search"
                      value={filters?.search}
                      onChange={(e) =>
                        setFilters({ ...filters, search: e.target.value })
                      }
                    />
                    <label htmlFor="">Search </label>
                  </div>
                </div>
                <div className="col-md-2 ">
                  <button
                    type="button"
                    onClick={() => {
                      setFilters({});
                    }}
                    className="btn btn-label-danger me-1 mb-1"
                  >
                    <i className="ri ri-restart-line"></i>
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      printElement("PrintDiv")
                    }}
                    className="btn btn-label-primary"
                  >
                    <i className="ri ri-printer-line"></i>
                  </button>
                </div>
                <div className="col-12">
                  <div className="table-responsive" id="PrintDiv">
                    <table className="table table-sm">
                      <thead>
                        <tr className="text-center text-nowrap">
                          <th>#</th>
                          <th>Student</th>
                          <th>Father name</th>
                          <th>Mobile no</th>
                          <th>Address</th>
                          <th>Joining Date</th>
                          <th>Hostel</th>
                          <th>Room & Bed</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {students?.map((student, index) => (
                          <tr key={student?.id}>
                            <td>{index + 1}</td>
                            <td>
                              {student?.student_name} (
                              {student?.registration_no})
                            </td>
                            <td>{student?.father_name}</td>
                            <td>{student?.mobile}</td>
                            <td>{student?.address}</td>
                            <td>{student?.joining_date}</td>
                            <td>{student?.hostel?.name}</td>
                            <td>
                              {`${student?.bed?.bed_no} (${student?.room?.room_no})`}
                            </td>
                            <td>
                              {student?.status === "1" ? "Active" : "Inactive"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer py-3 bg-label-primary">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
